import dynamic from 'next/dynamic';
import { CheckoutTitleWithTimerProps } from './CheckoutTitleWithTimer.types';
export const CheckoutTitleWithTimerMGP = dynamic<CheckoutTitleWithTimerProps>(() =>
  import('./CheckoutTitleWithTimer').then(module => module.CheckoutTitleWithTimer)
);
